import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Record, List } from 'immutable';
import classNames from 'classnames';

import { usePrevious } from '@xanadu/ui-shared/hooks';

import Tabs from '../Tabs';

import style from './Betslip.module.scss';

const Betslip = ({
  toggleDisplay,
  unsubmittedOffers,
  sidebarVisible,
  sidebarContent,
  sidebarMetadata,
  refreshOddsData,
  openOffers,
  betBuilderOffers,
  betslipSettledBets,
  updateUnsubmittedOfferByCid,
  updateOfferByUser,
  submitEditedOffersByIds,
  reviewUnsubmittedOffer,
  reviewOpenOffer,
  submitOffers,
  oddsType,
  betBuilderRestricted,
}) => {
  const previousOffersSize = usePrevious(unsubmittedOffers.size);
  const previousBetBuilderBetsSize = usePrevious(betBuilderOffers.size);

  const [activeTab, setActiveTab] = useState(
    unsubmittedOffers.size > 0 ? 'betslip' : 'active-bets'
  );

  const updateTabActive = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    refreshOddsData();
  }, [refreshOddsData]);

  useEffect(() => {
    if (unsubmittedOffers.size > 0
      && previousOffersSize !== unsubmittedOffers.size
      && activeTab !== 'betslip'
    ) {
      setActiveTab('betslip');
    }
  }, [unsubmittedOffers]);

  useEffect(() => {
    const anyErrors = unsubmittedOffers.find((offer) => offer.error.length)
    if (betBuilderOffers.size > 0
      && previousBetBuilderBetsSize
      && previousBetBuilderBetsSize !== betBuilderOffers.size
      && activeTab !== 'active-bets'
      && !anyErrors
    ) {
      setActiveTab('bet-builder');
    }
  }, [betBuilderOffers, unsubmittedOffers]);

  useEffect(() => {
    if (sidebarMetadata.betslipTab) {
      setActiveTab(sidebarMetadata.betslipTab);
    }
  }, [sidebarMetadata.betslipTab]);

  useEffect(() => {
    if (document.clientWidth <= 1200 && !sidebarVisible) {
      return () => {
        toggleDisplay(true);
      };
    }
    return () => {
      toggleDisplay(false);
    };
  }, [sidebarVisible, toggleDisplay]);

  const mainClass = classNames({
    [style.betslip]: true,
    [style['betslip--opened']]: sidebarContent === 'betslip'
  });

  return (
    <div className={mainClass}>
      <Tabs
        className={`${style.tabs}`}
        onUpdateTabActive={updateTabActive}
        typeView="normal"
        mainContent={activeTab}
        {...{
          unsubmittedOffers,
          openOffers,
          betslipSettledBets,
          updateUnsubmittedOfferByCid,
          updateOfferByUser,
          submitEditedOffersByIds,
          reviewUnsubmittedOffer,
          reviewOpenOffer,
          submitOffers,
          oddsType,
          betBuilderRestricted,
        }}
      />
    </div>
  );
};

Betslip.propTypes = {
  toggleDisplay: PropTypes.func.isRequired,
  unsubmittedOffers: PropTypes.instanceOf(List).isRequired,
  sidebarVisible: PropTypes.bool.isRequired,
  sidebarContent: PropTypes.string,
  sidebarMetadata: PropTypes.instanceOf(Record),
  refreshOddsData: PropTypes.func.isRequired,
  openOffers: PropTypes.instanceOf(List).isRequired,
  betBuilderOffers: PropTypes.instanceOf(List).isRequired,
  betslipSettledBets: PropTypes.instanceOf(List).isRequired,
  updateUnsubmittedOfferByCid: PropTypes.func.isRequired,
  updateOfferByUser: PropTypes.func.isRequired,
  submitEditedOffersByIds: PropTypes.func.isRequired,
  reviewUnsubmittedOffer: PropTypes.func.isRequired,
  reviewOpenOffer: PropTypes.func.isRequired,
  submitOffers: PropTypes.func.isRequired,
  oddsType: PropTypes.string,
  betBuilderRestricted: PropTypes.bool.isRequired,
};

export default Betslip;
